import * as actionTypes from './actionTypes';
import { http, bookingApi } from 'services/http';
import { TAB_PATIENT } from 'services/constants';
import { loadWorkflowTimeline } from './workflow';

// Export
export { loadInvoice, deleteInvoice, deleteInvoiceById, clearInvoice } from './invoices';
export { triggerWorkflow, loadWorkflowTimeline } from './workflow';

export const clearAppointment = () => dispatch => {
  dispatch({
    type: actionTypes.CLEAR_APPOINTMENT
  });
  dispatch(removeActiveAppointment());
};

export const loadPatientById = externalId => dispatch => {
  if (!externalId) return;

  return http
    .get(`patients/${externalId}`, {
      withoutLoader: true
    })
    .then(({ data }) => {
      dispatch(loadPatientSuccess(data));
    })
    .catch(() => {
      dispatch(loadPatientError());
    });
};

export const loadAppointmentById = (appointmentId, getPatientById, callback) => dispatch => {
  bookingApi
    .get(`bookings/${appointmentId}`)
    .then(({ data }) => {
      dispatch(loadAppointmentSuccess(data));
      if (typeof callback === 'function') callback(data);
      if (typeof getPatientById === 'function') {
        getPatientById(data.patient.externalId);
      }
      dispatch(loadWorkflowTimeline(appointmentId, data.appointment.entity.id));
    })
    .catch(() => {
      dispatch(loadAppointmentError());
    });
};

const loadAppointmentSuccess = data => ({
  type: actionTypes.LOAD_APPOINTMENT_BY_ID_SUCCESS,
  payload: data
});

const loadAppointmentError = () => ({
  type: actionTypes.LOAD_APPOINTMENT_BY_ID_ERROR
});

const loadPatientSuccess = data => ({
  type: actionTypes.LOAD_PATIENT_SUCCESS,
  payload: data
});

const loadPatientError = () => ({
  type: actionTypes.LOAD_PATIENT_ERROR,
  payload: []
});

export const changeTab = tab => ({
  type: actionTypes.CHANGE_ACTIVE_TAB,
  payload: tab || TAB_PATIENT
});

export const updateAppointment = (appointmentId, dataObj) => ({
  type: actionTypes.UPDATE_APPOINTMENT,
  payload: { appointmentId, dataObj }
});

export const clearTimeline = () => ({
  type: actionTypes.CLEAR_TIMELINE
});

export const verifyPatient = (patientId, externalPatientId) => dispatch => {
  return http
    .post('patients/' + patientId + '/validated')
    .then(() => {
      dispatch(verifyPatientSuccess());
      dispatch(loadPatientById(externalPatientId));
    })
    .catch(() => {
      dispatch(verifyPatientError());
    });
};

const verifyPatientSuccess = () => ({
  type: actionTypes.VERIFY_PATIENT_SUCCESS
});

const verifyPatientError = () => ({
  type: actionTypes.VERIFY_PATIENT_ERROR
});

export const blockPatient = (patientId, externalPatientId) => dispatch => {
  return http
    .post('patients/' + patientId + '/deleted')
    .then(() => {
      dispatch(blockPatientSuccess());
      dispatch(loadPatientById(externalPatientId));
    })
    .catch(() => {
      dispatch(blockPatientError());
    });
};

const blockPatientSuccess = () => ({
  type: actionTypes.BLOCK_PATIENT_SUCCESS
});

const blockPatientError = () => ({
  type: actionTypes.BLOCK_PATIENT_ERROR
});

export const clearPatient = () => ({
  type: actionTypes.CLEAR_PATIENT
});

//──── Active appointment ────────────────────────────────────────────────────────────────

export const addActiveAppointment = appointment => ({
  type: actionTypes.ADD_ACTIVE_APPOINTMENT,
  payload: appointment
});

export const removeActiveAppointment = () => ({
  type: actionTypes.REMOVE_ACTIVE_APPOINTMENT
});

export const updateActiveAppointment = dataObj => ({
  type: actionTypes.UPDATE_ACTIVE_APPOINTMENT,
  payload: { dataObj }
});
